/*                                     */
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
import { asExport } from "@gr-exports/async/core";
import { noop } from "@gr-common/async/function";
/**
 *
 */
export const domSync = asExport(o_util, "dom", {});
/**
 *
 *
 *
 */
export const stringToDocumentFragment = asExport(domSync, "stringToDocumentFragment", noop);
/**
 *
 *
 *
 */
export const getFirstElementByTagName = asExport(domSync, "getFirstElementByTagName", noop);
/**
 *
 *
 *
 */
export const getHeadElement = asExport(domSync, "getHeadElement", noop);
/**
 *
 *
 *
 */
export const getBodyElement = asExport(domSync, "getBodyElement", noop);
/**
 *
 */
export const domAsync = asExport(otto, "dom", {});
/**
 *
 *
 *
 *
 */
export const onLoad = asExport(domAsync, "onLoad");
/**
 *
 *
 *
 *
 */
export const onReady = asExport(domAsync, "onReady");
/**
 *
 *
 *
 */
export const onMount = asExport(domAsync, "onMount", noop);
/**
 *
 *
 *
 */
export const onUnmount = asExport(domAsync, "onUnmount", noop);
/**
 *
 *
 *
 *
 */
export const insertHtmlFragment = asExport(domAsync, "insertHtmlFragment", noop);
/**
 *
 *
 *
 *
 */
export const activateInlineScripts = asExport(domAsync, "activateInlineScripts", noop);
